/**
 * dehydrate - dehydrate this slice of state into a serializable form
 */
export default function dehydrate(state) {
  // You can't persist a fatal error! that's the point, reloading should try again.
  return state.delete("fatalError");
}



// WEBPACK FOOTER //
// ./src/state/app/dehydrate.js